// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provide-details label {
  font-size: 12px;
  display: block;
  line-height: 1.5;
  margin-bottom: 5px;
  font-weight: 500;
}
.provide-details input[type="text"] {
  width: 100%;
  font-size: 12px;
  padding: 10px;
  margin-bottom: 20px;
  border: 1px solid #d6d6d6;
  border-radius: 6px;
  outline: none;
}
.field-remark-wrapper label,
.provide-details-label {
  display: block;
  font-size: 12px;
  color: #222222;
  line-height: 1.5;
  margin-bottom: 5px;
}
.field-remark-wrapper textarea,
.provide-details-text {
  width: 100%;
  height: 64px;
  padding: 10px;
  font-size: 12px;
  border: 1px solid #d6d6d6;
  outline: none;
  border-radius: 6px;
  margin-bottom: 10px;
  max-height: 64px;
  font-size: 14px;
  color: #1984bc;
}
.field-label.note-label {
  margin-bottom: 20px;
}
.healthAndLifeStyle h3 {
  margin-bottom: 5px;
}
.healthAndLifeStyle .line-separation:last-child {
  border: none;
  margin: 0;
  padding: 0;
}
.healthAndLifeStyle .line-separation:last-child:before,
.healthAndLifeStyle .line-separation:last-child:after {
  content: none;
}
.healthAndLifeStyle .no-margin-text-field.label-value-wrapper {
  margin-right: 0px;
  margin-bottom: 0px;
}
.healthAndLifeStyle .marijuanaNote {
  font-size: 14px;
  color: #f00;
  margin-bottom: 15px;
  font-style: italic;
  line-height: 1.3;
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/healthAndLifestyle/healthAndLifestyle.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;AACA;;EAEE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,SAAS;EACT,UAAU;AACZ;AACA;;EAEE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".provide-details label {\n  font-size: 12px;\n  display: block;\n  line-height: 1.5;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n.provide-details input[type=\"text\"] {\n  width: 100%;\n  font-size: 12px;\n  padding: 10px;\n  margin-bottom: 20px;\n  border: 1px solid #d6d6d6;\n  border-radius: 6px;\n  outline: none;\n}\n.field-remark-wrapper label,\n.provide-details-label {\n  display: block;\n  font-size: 12px;\n  color: #222222;\n  line-height: 1.5;\n  margin-bottom: 5px;\n}\n.field-remark-wrapper textarea,\n.provide-details-text {\n  width: 100%;\n  height: 64px;\n  padding: 10px;\n  font-size: 12px;\n  border: 1px solid #d6d6d6;\n  outline: none;\n  border-radius: 6px;\n  margin-bottom: 10px;\n  max-height: 64px;\n  font-size: 14px;\n  color: #1984bc;\n}\n.field-label.note-label {\n  margin-bottom: 20px;\n}\n.healthAndLifeStyle h3 {\n  margin-bottom: 5px;\n}\n.healthAndLifeStyle .line-separation:last-child {\n  border: none;\n  margin: 0;\n  padding: 0;\n}\n.healthAndLifeStyle .line-separation:last-child:before,\n.healthAndLifeStyle .line-separation:last-child:after {\n  content: none;\n}\n.healthAndLifeStyle .no-margin-text-field.label-value-wrapper {\n  margin-right: 0px;\n  margin-bottom: 0px;\n}\n.healthAndLifeStyle .marijuanaNote {\n  font-size: 14px;\n  color: #f00;\n  margin-bottom: 15px;\n  font-style: italic;\n  line-height: 1.3;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
